import React, { memo, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { EmojiPicker, Icon } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const EmojiInsertButton = memo(({ onChange, cursorPosition, value }) => {
    const [visible, setVisible] = useState(false);

    const insertAtCursor = useCallback(
        (insertValue) => {
            const currentValue = value || '';
            return (
                currentValue.substring(0, cursorPosition) +
                insertValue +
                currentValue.substring(cursorPosition)
            );
        },
        [cursorPosition, value],
    );

    const handleInsertEmoji = useCallback(
        (emojiItem) => {
            if (!emojiItem?.emoji) {
                return;
            }

            onChange?.(insertAtCursor(emojiItem.emoji));
            setVisible(false);
        },
        [insertAtCursor, onChange],
    );

    return (
        <EmojiPicker
            popoverVisible={visible}
            onVisibleChange={setVisible}
            onSelectEmoji={(_name, selectedEmoji) => handleInsertEmoji(selectedEmoji)}
        >
            <button
                type="button"
                className="textarea-field-insert__btn"
                aria-label={getLiteral('label_emoji')}
            >
                <Icon name="moodSmall" />
            </button>
        </EmojiPicker>
    );
});

EmojiInsertButton.displayName = 'EmojiInsertButton';

EmojiInsertButton.propTypes = {
    onChange: PropTypes.func,
    cursorPosition: PropTypes.number.isRequired,
    value: PropTypes.string,
};

export default EmojiInsertButton;
